@if (isLoading) {
  <div class="bv-ind-profile__loading">
    <mat-icon class="bv-spinner">sync</mat-icon>
  </div>
}

@if (!isLoading) {
  <div class="bv-ind-profile">
    <!-- Header -->
    <div class="bv-ind-profile__header">
      <div class="bv-ind-profile__header-left">
        <div class="bv-ind-profile__avatar">
          {{individualData?.name?.charAt(0) | uppercase}}
        </div>
        <div class="bv-ind-profile__info">
          <div class="bv-ind-profile__name-row">
            <span class="bv-ind-profile__name">{{individualData?.fullname || ('BUTTONS.NUEVA' | translate) + ' ' + ('LABELS.PERSON' | translate)}}</span>
            @if (individualData?.type === 0) {
              <span class="bv-ind-profile__badge">{{'IND.INDIVIDUAL' | translate}}</span>
            }
            @if (individualData?.type === 1) {
              <span class="bv-ind-profile__badge">{{'IND.LEGAL_ENTITY' | translate}}</span>
            }
          </div>
          @if (individualData?.email) {
            <span class="bv-ind-profile__email">{{individualData.email}}</span>
          }
        </div>
      </div>
    </div>

    <!-- Tabs -->
    <mat-tab-group class="bv-ind-profile__tabs">
      <mat-tab [label]="'INDV.DATA' | translate">
        <div class="bv-ind-profile__tab-content">
          <app-data-individual [isLoading]="isLoading" [individualData]="individualData"></app-data-individual>
        </div>
      </mat-tab>
      @if (currentID) {
        <mat-tab [label]="'BUTTONS.LINKAGES' | translate">
          <div class="bv-ind-profile__tab-content">
            <app-linkages-individual [linkages]="individualData?.links"
            [individual_fullname]="individualData?.fullname"></app-linkages-individual>
          </div>
        </mat-tab>
      }
    </mat-tab-group>
  </div>
}
